<template>
    <div>

      <navbar :title="fad" :box="box"/>
      <van-tabs @click="onClick" v-model="active">
        <van-tab name="Cüzdan" title="Cüzdan">
          <van-divider v-if="total >= siparis.fiyat && talepVarmi == 0">Cüzdan hesabınızdan {{parabirimi(siparis.fiyat)}} harcanarak sipariş eklenecektir.</van-divider>
          <van-divider v-else>Cüzdanınızda yeterli bakiye yok YA DA bekleyen ödeme talebi var.</van-divider>
      <van-button @click="sipbaslakk()" v-if="total >= siparis.fiyat && siparis.odeme_sekli === 'Cüzdan'&& talepVarmi == 0" size="large" color="#f00" plain>  ÖDEME YAP  </van-button>
        </van-tab>

        <van-tab name="Kredi Kartı"  title="Kredi Kartı ile">
          <van-field style="margin-top:10px;"
            v-model="moka.cc_name"
            left-icon="manager-o"
            placeholder="Kart Üzerindeki isim"
            :rules="[{ required: true, message: 'Boş geçilemez' }]"
          />
          <van-grid :column-num="4" style="margin-bottom:5px">
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="kart2.no1"
                placeholder="****"
                type="number"
                maxlength="4"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="kart2.no2"
                placeholder="****"
                type="number"
                maxlength="4"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="kart2.no3"
                placeholder="****"
                type="number"
                maxlength="4"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="kart2.no4"
                placeholder="****"
                type="number"
                maxlength="4"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
          </van-grid>
          <van-grid :column-num="3" style="margin-bottom:5px">
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="moka.cc_exp_mo"
                placeholder="08"
                type="number"
                maxlength="2"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="moka.cc_exp_yr"
                placeholder="2022"
                type="number"
                maxlength="4"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
            <van-grid-item>
              <van-field style="font-size:18px; padding:0 15px;font-weight:bold;"
                v-model="moka.CvcNumber"
                placeholder="CVC"
                type="number"
                maxlength="8"
                :rules="[{ required: true, message: 'Boş geçilemez' }]"
              />
            </van-grid-item>
          </van-grid>
          <van-button @click="sipbasla()" size="large" color="#f00" plain>  ÖDEME YAP  </van-button>          
        </van-tab>
        <van-tab name="Havale" title="Havale ile">
          <van-cell-group>
            <van-cell title="ONB Finansbank" />
            <van-cell title="TR80 0011 1000 0000 0083 5484 66"/> 
            <van-cell title="Kerim Göncü"/>
          </van-cell-group>
          <van-button @click="sipbaslakk()" size="large" color="#f00" plain>  ÖDEME YAP  </van-button>
        </van-tab>
      </van-tabs>
      <van-field style="margin:5px auto"
        v-model="siparis.notu"
        rows="2"
        autosize
        label="Sipariş Notu"
        type="textarea"
        maxlength="100"
        placeholder="Farklı kargo adresi vs."
        show-word-limit
/> 

      <van-grid :column-num="3">
        <van-grid-item icon="pending-payment" :text="parabirimi(siparis.fiyat)" />
        <van-grid-item icon="logistics" :text="'+'+parabirimi(kargo.fiyat)" />
        <van-grid-item icon="paid" :text="parabirimi(total)" />
      </van-grid>
    

      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import { Dialog } from 'vant';
import { Notify } from 'vant';
import {Toast} from 'vant';
import {router}  from '@/router';
import navbar from './nav'
export default {
  components:{
    navbar
  },
  data() {
    return {
      showp: false,
      tCuzdan:0,
      active:0,
      kart2:{
        no1:'',
        no2:'',
        no3:'',
        no4:'',
      },
      moka:{
          "cc_name":'',
          "cc_card_no": '',
          "cc_exp_mo": '',
          "cc_exp_yr": "",
          "CvcNumber": "",
          "sipno":"",
          "total":0
      },
      Banka:{},
      payType:"cüzdan",
      posts:[],
      cuzdan:[],
      sepet:'',
      show:false,
      fad:"Ödeme",
      
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
     
      siparis:{
         sip_no:'',
         uye_kod:helper.settings.ayar().uye,
         tarih:helper.funcs.trtgosternoktali(new Date()),
         notu:'',
         fiyat:0,
         puan:0,
         kariyer_puan:0,
         gun:helper.settings.donem().gun,
         ay:helper.settings.donem().ay,
         yil:parseInt(helper.settings.donem().yil),
         odeme_sekli:'Cüzdan'
      },
      kargo:{
        sip_no:'',
        id:0,
        adet:1,
        fiyat:0,
        kdv:0,
        puan:0,
        kpuan:0
      }
      ,hata:'',
      cuzdanHareket:[],
      talepVarmi :0

    };
  },
  computed: {
    total() {
      return this.cuzdanHareket.reduce(
        (acc, item) => acc + item.tutar,
        0
      );
    },    
  }, 
  created (){
   this.show = true

   userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {
     this.odemetalebiVarmi()
      this.getProduct()
      this.gercekCuzdan();
      })
    .catch(err => {
      //userService.logout()
      })
  },
    methods : {

odemetalebiVarmi(){
  helper.request.get("odeme_talepleri/"+this.siparis.uye_kod)
  .then(res => {
    if (res.status) {
      this.talepVarmi = 1
    }
  })
},

          showPopup() {
      this.showp = true;
    },
      sipbaslakk(payType){

        Dialog.confirm({
        title: 'Onaylıyor musunuz ?',
        message:'Sipariş eklenecek',
        }).then(() => {
          this.show = true
          this.sipno_kontrol(Math.floor(Math.random() * 100000000000000) + 1)
          .then(res=>{
            if(res.status){this.sipno_kontrol(Math.floor(Math.random() * 100000000000000) + 1)}
            else{
              this.siparis.sip_no = res.no
               this.kargo.sip_no = res.no
                this.moka.sipno = res.no
                this.sipekle()
                  .then(()=>{ this.infoekle().then(()=> { this.sipupdate()})})
                  .catch(()=>{
                    this.sipekle()
                  })
            }
          })
        })
      },
      sipbasla(payType){
        if (this.moka.cc_name && this.moka.CvcNumber && this.moka.cc_exp_mo && this.moka.cc_exp_yr){
        Dialog.confirm({
        title: 'Onaylıyor musunuz ?',
        message:'Sipariş eklenecek',
        }).then(() => {
          this.show = true
          this.sipno_kontrol(Math.floor(Math.random() * 100000000000000) + 1)
          .then(res=>{
            if(res.status){this.sipno_kontrol(Math.floor(Math.random() * 100000000000000) + 1)}
            else{
              this.siparis.sip_no = res.no
               this.kargo.sip_no = res.no
                this.moka.sipno = res.no
                this.sipekle()
                  .then(()=>{ this.infoekle().then(()=> { this.sipupdate()})})
                  .catch(()=>{
                    this.sipekle()
                  })
            }
          })
        })
        }
        else{
          Toast("Girdileri kontrol et")
        }
      },
      sipekle(){
        return new Promise((resolve, reject) => {
          helper.request.post('sipekle',this.siparis)
            .then((res)=>{
              resolve(res.no)
            })
            .catch(()=>{
              reject()
            })
        })
      },
      infoekle(){
        return new Promise((resolve, reject) => {
          var pros = 0
          var err = 0
          var items = JSON.parse(localStorage.getItem('ayuBox')) || [];
            this.posts.forEach(element => {
              let data = {
                sip_no:this.siparis.sip_no,
                urunid:element.id,
                adet:element.adet,
                fiyat:element.fiyat,
                kdv:element.kdv,
                puan:element.puan,
                kariyer_puan:element.kpuan
              }
              helper.request.post('infoekle',data)
              .then((res)=>{
                this.remove(items.baskets.findIndex(obj => obj.id===res.id))
              })
              pros++ 
            });
            if(this.posts.length === pros){ resolve() }
        })
      },
      gercekCuzdan(){
        helper.request.get("gercekCuzdan/"+this.siparis.uye_kod)
        .then(res => { this.cuzdanHareket = res.results })
      },
      sipupdate(){
       
          if(this.siparis.odeme_sekli === "Kredi Kartı"){
          this.moka.cc_card_no = this.kart2.no1+''+this.kart2.no2+''+this.kart2.no3+''+this.kart2.no4
           let url = "https://ayurlifeworld.com/panel/3d_check.php"
            fetch(url, {
              method: 'POST',
              headers:{"Content-Type":"application/json; charset=UTF-8",},
              body: JSON.stringify(this.moka)
            })
            .then((res) => {
                return res.json();
            })
            .then((res) =>{
             if (res.Data !=null){
               window.location.href = res.Data}
             else{
               Toast(res.ResultMessage)
             }

            })
            .catch(function (error) {
              Toast(error.message)
              //swal("Hata ile Karşılaşıldı","",error);
            });
         // console.log(this.moka)
          }
          else if(this.siparis.odeme_sekli === "Cüzdan")
          {
            let data = {
              sip_no : this.siparis.sip_no,
              durum_id:1,
              durum:'Başarılı Ödeme'
            }
            helper.request.post('sipupdate',data)
            .then(res => {
                  let newData = {
                    uye_kod : this.siparis.uye_kod,
                    tutar:(this.siparis.fiyat)* -1,
                    tip:'Ürün alımı'
                  }
                  helper.request.post("odemeEkle",newData)
              Toast("Sipariş Ekleme Başarılı")
              router.push('siparis')
              this.show = false
            })
            .catch(()=>{
              Toast("Birşeyler ters gitti")
            })

          } // cüzdana ödeme ekleme işlemi yapılacak          
          else{
            let data = {
              sip_no : this.siparis.sip_no,
              durum_id:5, //1
              durum:'Ödeme Bekleyen Sipariş' //başarılı ödeme
            }
            helper.request.post('sipupdate',data)
            .then(res => { 
              this.show = false
              Toast("Sipariş Ekleme Başarılı")
              router.push('siparis')
            })
            .catch((err)=>{
              Toast("Birşeyler ters gitti")
              this.show = false
            })
          }

      },

      getProduct(){
        var pros = 0
        if (JSON.parse(localStorage.getItem('ayuBox')).baskets.length>0){
        JSON.parse(localStorage.getItem('ayuBox')).baskets.forEach(element => {
          helper.request.get('urunler/'+element.id)
          .then(res =>{
            let data = {
                    fiyat:res.results[0].fiyat,
                    puan:res.results[0].puan,
                    kpuan:res.results[0].kariyer_puan,
                    adet:element.adet,
                    id:element.id,
                    kdv:res.results[0].kdv,
                  }
                this.posts.push(data)
                this.siparis.fiyat+=(data.adet*data.fiyat)
                this.siparis.puan+=(data.adet*data.puan)
                this.siparis.kariyer_puan+=(data.adet*data.kpuan)
          })
          .catch(err => {Notify({ type: 'danger', message: err.message });})
          pros++
         
        });

          if(JSON.parse(localStorage.getItem('ayuBox')).baskets.length === pros)
          {
            //console.log(this.siparis)
            setTimeout(() => {
             if (this.siparis.fiyat<200) { 
               
                  this.kargo.fiyat = 10
                  this.moka.total = this.siparis.fiyat + 10 // sadece kredi kartına gönderilecek değer için
                  this.posts.push(this.kargo)
                  this.show = false

             }
             else{
               this.moka.total = this.siparis.fiyat
               this.show = false
             }
            }, 1000);
 
          }
        }
        else{
          router.push('/urunler')
        }

        
      },
      parabirimi(res){
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
      },
      sipno_kontrol(value){
      return new Promise((resolve, reject) => {
          helper.request.get("sipno/"+value)
          .then(res=>{
            resolve(res)
          })
      })
      },
      onClick(name) { 
        this.siparis.odeme_sekli = name },
      kargohesap(){
        this.kargo.fiyat = 10
        this.moka.total = this.siparis.fiyat + 10 // sadece kredi kartına gönderilecek değer için
        this.posts.push(this.kargo)
        this.show = false
    },
      remove (index) {
                var items = JSON.parse(localStorage.getItem('ayuBox')) || [];
                items.baskets.splice(index,1)
                localStorage.setItem('ayuBox', JSON.stringify(items))
 
      },    
  } 
};
</script>
<style>
body{background:#f2f2f2}
  .para{font-size: 24px;}
  .delete-button {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/pays.vue